import {
  FaFileImport,
  FaFileExport,
  FaThLarge,
  FaList,
} from "react-icons/fa";

import { FiTrash2, FiSettings } from "react-icons/fi";
import { IoIosAdd } from "react-icons/io";
import CustomSelect from "../../../Common/CustomSelect";
import "./ArticleToolbar.css";

const ArticleToolbar = ({
  search,
  setSearch,
  hierarchy,
  hierarchies,
  onHierarchyChange,
  view,             // NEW
  setView,          // NEW
  selectedCount,
  totalSelectableCount,
  allSelected,
  onToggleSelectAll,
  onAdd,
  onImport,
  onExport,
  onDeleteSelected,
  onOpenSettings,
}) => {
  return (
    <div className="article-toolbar">

      <div className="article-toolbar-left">
        <button
          className="toolbar-buttons"
          onClick={onAdd}
        >
          <span><IoIosAdd /></span> Add Article
        </button>


        <button
          className="toolbar-buttons btn-import"
          onClick={onImport}
        >
          <FaFileImport />
          Import
        </button>

        <button
          className="toolbar-buttons btn-export"
          onClick={onExport}
        >
          <FaFileExport />
          Export
        </button>

        <label className="select-all-label">
          <input
            type="checkbox"
            checked={allSelected}
            disabled={!totalSelectableCount}
            onChange={(e) => onToggleSelectAll?.(e.target.checked)}
          />
          Select All
        </label>

        <button
          className="btn-delete-all"
          disabled={!selectedCount}
          onClick={onDeleteSelected}
        >
          <FiTrash2 />
          Delete ({selectedCount})
        </button>

      </div>

      <div className="article-toolbar-center">

        <input
          type="search"
          placeholder="Search articles..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="article-search"
        />

      </div>

      <div className="article-toolbar-right">

        <div className="article-view-toggle">
          <button
            className={`article-view-btn ${view === "tree" ? "active" : ""}`}
            onClick={() => setView("tree")}
            title="Tree view"
          >
            <FaList />
          </button>
          <button
            className={`article-view-btn ${view === "catalog" ? "active" : ""}`}
            onClick={() => setView("catalog")}
            title="Catalog view"
          >
            <FaThLarge />
          </button>
        </div>

        {view === "tree" && (
          <>
            <label>Hierarchy</label>

            <CustomSelect
              value={hierarchy?.id}
              onChange={onHierarchyChange}
              options={hierarchies.map((h) => ({
                value: h.id,
                label: h.name,
              }))}
              menuWidth={220}
            />

          </>
        )}

      </div>
      <button
        className="toolbar-buttons"
        onClick={onOpenSettings}
        title="Default Article Attributes"
      >
        <FiSettings />
        Settings
      </button>
    </div>
  );
};

export default ArticleToolbar;